/**
 * Focus Shell
 *
 * Contenedor principal del shell.
 * Estructura: FocusHeader arriba + AppContainer abajo (flex column, 100vh)
 */



import { useEffect } from 'react'
import { FocusHeader } from './FocusHeader'
import { AppContainer } from './AppContainer'
import { colors } from '@/lib/tokens'
import { broadcastSync } from '@/services/session/BroadcastSync'
import { useShellStore } from '@/store/shell-store'
import { useServerPing } from '@/hooks/useServerPing'

export function FocusShell() {
  const restoreFromPopout = useShellStore(state => state.restoreFromPopout)

  // Server ping — heartbeat every 5s
  useServerPing()

  // Escuchar mensajes de cierre de pop-out windows
  // Usamos tanto evento local (mismo window) como BroadcastChannel (otros windows)
  useEffect(() => {
    console.log('[FocusShell] Setting up popout close listeners')

    // Handler para restaurar tab
    const handlePopoutClosed = (instanceId: string) => {
      console.log(`[FocusShell] Restoring tab with instanceId: ${instanceId}`)
      restoreFromPopout(instanceId)
    }

    // Listener para evento local (CustomEvent desde mismo window)
    const localHandler = (event: Event) => {
      const detail = (event as CustomEvent).detail
      console.log('[FocusShell] Local popout-closed event received:', detail)
      handlePopoutClosed(detail.instanceId)
    }
    window.addEventListener('popout-closed', localHandler)

    // Listener para BroadcastChannel (desde otros windows)
    const unsubscribe = broadcastSync.on('POPOUT_CLOSED', (message) => {
      console.log('[FocusShell] BroadcastChannel POPOUT_CLOSED received:', message)
      handlePopoutClosed(message.instanceId)
    })

    return () => {
      console.log('[FocusShell] Cleaning up popout close listeners')
      window.removeEventListener('popout-closed', localHandler)
      unsubscribe()
    }
  }, [restoreFromPopout])

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      height: '100vh',
      width: '100vw',
      overflow: 'hidden',
      background: colors.background,
    }}>
      {/* Header - fixed height */}
      <FocusHeader />

      {/* App Container - fills remaining space */}
      <div style={{
        flex: 1,
        overflow: 'hidden',
      }}>
        <AppContainer />
      </div>
    </div>
  )
}
